function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-www:not(.animated) .animable {opacity: 0;}svg#freepik_stories-www.animated #freepik--Floor--inject-12 {animation: 6s Infinite  linear floating;animation-delay: 0.5s;}svg#freepik_stories-www.animated #freepik--Device--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-www.animated #freepik--Browser--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight,6s Infinite  linear shake;animation-delay: 0s,1s;}svg#freepik_stories-www.animated #freepik--Character--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,6s Infinite  linear wind;animation-delay: 0s,1s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes shake {                10%, 90% {                    transform: translate3d(-1px, 0, 0);                  }                  20%, 80% {                    transform: translate3d(2px, 0, 0);                  }                  30%, 50%, 70% {                    transform: translate3d(-4px, 0, 0);                  }                  40%, 60% {                    transform: translate3d(4px, 0, 0);                  }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        ");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "active",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#32DFEC",
  floodOpacity: 1,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "hover",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff0000",
  floodOpacity: 0.5,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
})));

var SvgExp = function SvgExp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-www",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12",
    className: "animable",
    style: {
      transformOrigin: "250px 349.12px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-12",
    d: "M81.82,446.22c-92.88-53.63-92.88-140.58,0-194.2s243.48-53.63,336.36,0,92.88,140.57,0,194.2S174.7,499.84,81.82,446.22Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "250px 349.12px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-12",
    className: "animable",
    style: {
      transformOrigin: "256.458px 343.24px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-12",
    d: "M207.67,456.34,65.87,374.41c-5.53-3.2-5.53-8.42,0-11.62l229.6-132.66a9.23,9.23,0,0,1,8.29,0L449,314.08a4.38,4.38,0,0,1,0,7.59L216,456.34A9.23,9.23,0,0,1,207.67,456.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "256.458px 343.24px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 384.29,
    cy: 414.64,
    rx: 52.56,
    ry: 30.34,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "384.29px 414.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "243.188px 291.214px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "50.3446px 304.391px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.51,326.81s-.3-21.35-9.17-38.78S49.06,258.94,35.7,256.54s-25.46,8.9-11.9,18.84,38.28,21.16,46.89,54.14Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "49.185px 292.867px"
    },
    id: "elrjkgxfphb5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els9ctydj9kzo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.51,326.81s-.3-21.35-9.17-38.78S49.06,258.94,35.7,256.54s-25.46,8.9-11.9,18.84,38.28,21.16,46.89,54.14Z",
    style: {
      opacity: 0.15,
      transformOrigin: "49.185px 292.867px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.11,320.93a.35.35,0,0,0,.14,0,.71.71,0,0,0,.49-.89c-10.72-36.4-36.31-53.7-48.35-57.76a.72.72,0,0,0-.46,1.36c11.79,4,36.87,21,47.43,56.8A.71.71,0,0,0,77.11,320.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "53.1316px 291.597px"
    },
    id: "el4w89tzdn54l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12",
    className: "animable",
    style: {
      transformOrigin: "51.1502px 325.48px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.86,347c-5,2.85-7.8,4.7-16.89,5.46a48.11,48.11,0,0,1-19.1-2.59c-1.69-.61-4.3-1.94-2.83-3.56.76-.84,9.68-2.26,12.87-6a58.85,58.85,0,0,1-12.51,2.22,16.33,16.33,0,0,1-10.85-3.33c-2.95-2.46-4.54-6.13-6-9.67-.51-1.21-1-2.69-.21-3.74a3.78,3.78,0,0,1,2.16-1.15l10.13-2.83c2.21-.47.65-1.92-.18-2.05a19.1,19.1,0,0,0-3.68-.16c-3.87.21-8.14.94-11.3-1.31A9.45,9.45,0,0,1,20,312.39c-.16-.8-.83-11.24-.37-11.37a51.85,51.85,0,0,1,7.73-1.34c2.45-.29,4.84-.4,7.28-.73a61,61,0,0,1,8.32-.54,5.1,5.1,0,0,1,2.74.54,4.42,4.42,0,0,1,1.68,3.37,15.87,15.87,0,0,0,.52,3.84c1.18-.1,1.57-1.65,1.54-2.84s0-2.68,1.07-3.19a2.84,2.84,0,0,1,1.78,0,48.6,48.6,0,0,1,11,3.65,12.63,12.63,0,0,1,4.33,2.95c1.7,2,2.2,4.72,2.22,7.33s-.39,5.2-.22,7.8c2-1.82,4.87-7.35,5.09-10.07,4.38,2.81,7,8.62,7.79,16.55a80.28,80.28,0,0,1-.32,17.45C82.07,345.93,82,346.86,81.86,347Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "51.1502px 325.48px"
    },
    id: "el7cxnmx3jx73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj8dnzt40ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.86,347c-5,2.85-7.8,4.7-16.89,5.46a48.11,48.11,0,0,1-19.1-2.59c-1.69-.61-4.3-1.94-2.83-3.56.76-.84,9.68-2.26,12.87-6a58.85,58.85,0,0,1-12.51,2.22,16.33,16.33,0,0,1-10.85-3.33c-2.95-2.46-4.54-6.13-6-9.67-.51-1.21-1-2.69-.21-3.74a3.78,3.78,0,0,1,2.16-1.15l10.13-2.83c2.21-.47.65-1.92-.18-2.05a19.1,19.1,0,0,0-3.68-.16c-3.87.21-8.14.94-11.3-1.31A9.45,9.45,0,0,1,20,312.39c-.16-.8-.83-11.24-.37-11.37a51.85,51.85,0,0,1,7.73-1.34c2.45-.29,4.84-.4,7.28-.73a61,61,0,0,1,8.32-.54,5.1,5.1,0,0,1,2.74.54,4.42,4.42,0,0,1,1.68,3.37,15.87,15.87,0,0,0,.52,3.84c1.18-.1,1.57-1.65,1.54-2.84s0-2.68,1.07-3.19a2.84,2.84,0,0,1,1.78,0,48.6,48.6,0,0,1,11,3.65,12.63,12.63,0,0,1,4.33,2.95c1.7,2,2.2,4.72,2.22,7.33s-.39,5.2-.22,7.8c2-1.82,4.87-7.35,5.09-10.07,4.38,2.81,7,8.62,7.79,16.55a80.28,80.28,0,0,1-.32,17.45C82.07,345.93,82,346.86,81.86,347Z",
    style: {
      opacity: 0.3,
      transformOrigin: "51.1502px 325.48px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81,346a.61.61,0,0,1-.53-.32c-14.19-27.24-45.57-38.72-53.2-40.3a.6.6,0,0,1,.25-1.18c7.74,1.61,39.61,13.26,54,40.93a.59.59,0,0,1-.25.8A.55.55,0,0,1,81,346Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.1903px 325.093px"
    },
    id: "ell9djltu5yer",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.82,330.27a.61.61,0,0,1-.6-.56.59.59,0,0,1,.55-.64c15.66-1.23,20.72-7.36,20.77-7.42a.6.6,0,0,1,.94.74c-.21.27-5.37,6.6-21.61,7.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "50.3994px 325.863px"
    },
    id: "el55g9bqtk6dw",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "443.59px 269.648px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460,254.3c-6.94,7.59-19.67,20.08-27.07,32.14a.41.41,0,0,0-.05.09c-2.89,4.73-5,9.39-5.53,13.66l-.52,7.71-3.17-1.83-.53-.31-1.31-.75h0a6.27,6.27,0,0,1-3.12-5.25c-.51-18.8,4.52-34.78,9.38-44.45,6.65-13.21,19.11-26.68,29.94-25.36C468.13,231.18,469.72,243.72,460,254.3Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "442.585px 268.88px"
    },
    id: "elxn1mowgpl8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt4pu56tn1wg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460,254.3c-6.94,7.59-19.67,20.08-27.07,32.14a.41.41,0,0,0-.05.09c-2.89,4.73-5,9.39-5.53,13.66l-.52,7.71-3.17-1.83-.53-.31-1.31-.75h0a6.27,6.27,0,0,1-3.12-5.25c-.51-18.8,4.52-34.78,9.38-44.45,6.65-13.21,19.11-26.68,29.94-25.36C468.13,231.18,469.72,243.72,460,254.3Z",
    style: {
      opacity: 0.15,
      transformOrigin: "442.585px 268.88px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.93,237.24c-13.26,8.38-32.19,37.59-31.76,68.52l-1.31-.75c-.11-31.12,19-60.4,32.37-68.87a.65.65,0,0,1,.7,1.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "438.546px 270.899px"
    },
    id: "elle5eakygdtc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.9,279.08c-2.31,6.27-15.49,11.71-25.22,20.76a63.17,63.17,0,0,0-6.68,7.25,6.12,6.12,0,0,1-7.89,1.52h0l-1.16-.67-.08,0-3.17-1.83a64,64,0,0,1,9.22-19.54.41.41,0,0,1,.05-.09c6.44-9.34,14.39-16.09,19.94-17.62C463.82,265.82,470.67,271.55,467.9,279.08Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "446.108px 288.733px"
    },
    id: "el2i7ubut44b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els6msywuqnlp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.9,279.08c-2.31,6.27-15.49,11.71-25.22,20.76a63.17,63.17,0,0,0-6.68,7.25,6.12,6.12,0,0,1-7.89,1.52h0l-1.16-.67-.08,0-3.17-1.83a64,64,0,0,1,9.22-19.54.41.41,0,0,1,.05-.09c6.44-9.34,14.39-16.09,19.94-17.62C463.82,265.82,470.67,271.55,467.9,279.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "446.108px 288.733px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.63,275.31c-8,2.25-23.41,12-30.52,33.3l-1.16-.67c7.21-21.59,22.56-31.41,31.33-33.88a.65.65,0,1,1,.35,1.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "443.045px 291.318px"
    },
    id: "elduiin0jqpaj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-12",
    className: "animable",
    style: {
      transformOrigin: "254.91px 229.288px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-12",
    className: "animable",
    style: {
      transformOrigin: "254.91px 229.288px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1,359.31c0,3.47,2.6,7.78,5.8,9.63l126.29,72.93a12.82,12.82,0,0,0,11.6,0L439.16,313.48c3.21-1.85,5.8-6.16,5.8-9.63s-2.59-7.79-5.8-9.64L312.88,221.29a12.82,12.82,0,0,0-11.6,0L78.9,349.68C75.7,351.53,73.1,355.84,73.1,359.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.03px 331.58px"
    },
    id: "elc462k2201xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,303.85c0,3.47-2.6,7.77-5.8,9.63L216.79,441.87a12,12,0,0,1-5.8,1.38V430.69a12,12,0,0,0,5.8-1.39L439.17,300.91c2.8-1.61,3.15-4.12,1.05-6C442.91,297.05,445,300.77,445,303.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "327.995px 369.081px"
    },
    id: "elgo2u05kzqh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,430.7v12.55a11.87,11.87,0,0,1-5.8-1.38L78.9,368.94c-3.2-1.85-5.8-6.16-5.8-9.63,0-3.26,2.29-7.25,5.21-9.26-2.6,1.86-2.4,4.6.59,6.33l126.29,72.93A11.87,11.87,0,0,0,211,430.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.05px 396.651px"
    },
    id: "elmr6ix6g7kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66,349.88c-2.84-2-2.84-4.66-2.84-8.36V154.64a12.79,12.79,0,0,1,5.8-10L293,16.21c3.21-1.85,6.16-.51,9.17,1.22s4.92,3.24,4.92,6.93V211.24a12.84,12.84,0,0,1-5.8,10L78.9,349.68C74.05,353,70.74,352.06,67.66,349.88Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "185.955px 183.585px"
    },
    id: "elsclcuqzww7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,349.68c-4.85,3.26-8.16,2.38-11.24.2-2.83-2-2.84-4.66-2.84-8.36V154.65a11.87,11.87,0,0,1,1.69-5.71l8.28,4.81a11.75,11.75,0,0,0-1.69,5.7V346.33C73.1,350,75.69,351.52,78.9,349.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "71.86px 250.384px"
    },
    id: "elx0vlbgau3yt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.08,24.36c0-3.69-2.6-5.19-5.8-3.35L78.9,149.41a11.66,11.66,0,0,0-4.1,4.33l-8.28-4.81h0a12,12,0,0,1,4.11-4.34L293,16.21c3.2-1.85,6.16-.51,9.16,1.22S307.08,20.67,307.08,24.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "186.8px 84.5296px"
    },
    id: "elf8okvxn3cf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,156.1,296.42,32.34c1.92-1.11,3.48-.21,3.48,2V205.76a7.7,7.7,0,0,1-3.48,6L82,335.54c-1.92,1.11-3.48.21-3.48-2V162.12A7.68,7.68,0,0,1,82,156.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.21px 183.94px"
    },
    id: "ela9qf7nye6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,156.1a7.68,7.68,0,0,0-3.48,6V332.49l213.14-123a7.7,7.7,0,0,0,3.48-6V33.07Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "186.83px 182.78px"
    },
    id: "el1ruf5nazwyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1tciz80gub0j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82,156.1a7.68,7.68,0,0,0-3.48,6V332.49l213.14-123a7.7,7.7,0,0,0,3.48-6V33.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "186.83px 182.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,350,301.37,230.85a6.38,6.38,0,0,1,5.8,0l6,3.15c1.6.93,1.6,2.43,0,3.35L106.73,356.5a6.38,6.38,0,0,1-5.8,0l-6-3.13C93.35,352.44,93.35,350.94,95,350Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "204.062px 293.675px"
    },
    id: "eldrlwire5kho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,359.65,317.55,240.47a6,6,0,0,1,5.3-.29l53.73,31c1.32.77,1.1,2.14-.5,3.06l-206.17,119a5.94,5.94,0,0,1-5.31.3L110.65,362.7C109.32,361.94,109.54,360.57,111.14,359.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.611px 316.863px"
    },
    id: "el6z9jjxm54i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,290l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.3a1,1,0,0,0-.91.06l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,288.3,290Zm-9-12.67-6.47,3.73c-.27.16-.31.39-.09.52l5.71,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,279.28,277.37ZM258.4,289.43l-10.94,6.31c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l10.93-6.31c.28-.16.32-.4.09-.53l-5.7-3.29A1,1,0,0,0,258.4,289.43Zm11.43-6.61-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.4.09-.53l-5.7-3.29A1,1,0,0,0,269.83,282.82Zm-25.35,14.64L238,301.19c-.28.16-.32.4-.1.52l5.71,3.3a1,1,0,0,0,.9-.06l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,244.48,297.46ZM235,302.92l-6.46,3.73c-.28.15-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9,0l6.47-3.73c.27-.16.31-.4.09-.53l-5.7-3.29A1,1,0,0,0,235,302.92Zm24,14.4,6.46-3.74c.28-.15.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29A1,1,0,0,0,259,317.32Zm-9.44,5.45L256,319c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91,0L243,319c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,249.54,322.77Zm-9.45,5.45,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.47,3.73c-.27.16-.31.39-.08.52l5.7,3.29A1,1,0,0,0,240.09,328.22Zm-9.45,5.46,6.47-3.73c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29A1,1,0,0,0,230.64,333.68Zm48.21-38.19,6.46-3.73c.28-.16.32-.39.09-.52L279.7,288a1,1,0,0,0-.9.05l-6.47,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,278.85,295.49Zm-10.42,16.37,14.41-8.32c.28-.16.32-.39.09-.52l-14.66-8.47a1,1,0,0,0-.91.05l-7.45,4.31c-.28.16-.32.39-.09.52l8.15,4.7c.22.13.18.37-.09.53l-6,3.44c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,268.43,311.86Zm-42.84-3.49-6.47,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,225.59,308.37Zm-9.45,5.45-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.06l6.47-3.73c.27-.15.31-.39.09-.52L217,313.77A1,1,0,0,0,216.14,313.82ZM163.62,371.9a1,1,0,0,0,.9,0l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05L158,368.09c-.27.16-.31.39-.09.52Zm-23-14.45-6.47,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,140.58,357.45Zm11.59,10.71a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.3a1,1,0,0,0-.91.06l-6.46,3.73c-.28.16-.32.39-.09.52Zm26.29,6,6.46-3.73c.28-.16.32-.4.09-.53l-5.7-3.29a1,1,0,0,0-.9.05L172,370.4c-.28.15-.32.39-.09.52l5.7,3.29A1,1,0,0,0,178.46,374.16Zm-10.35,5.5a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.39-.09.52ZM150,352l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.3A1,1,0,0,0,150,352Zm47.23-27.27-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9,0l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,197.25,324.73Zm-37.78,21.81L153,350.27c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91,0L166,350.3c.28-.15.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,159.47,346.54Zm47.22-27.26L200.23,323c-.27.15-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.4.09-.53l-5.7-3.29A1,1,0,0,0,206.69,319.28Zm-18.89,10.9-6.46,3.73c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91-.06l6.46-3.73c.27-.15.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,187.8,330.18Zm-9.44,5.46-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.4.09-.52l-5.7-3.3A1,1,0,0,0,178.36,335.64Zm-9.45,5.45-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,168.91,341.09Zm42.84,3.49,6.47-3.73c.27-.16.31-.39.09-.52L212.6,337a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.3A1,1,0,0,0,211.75,344.58Zm88.41-79.27-6.47,3.74c-.27.15-.31.39-.09.52l5.71,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.4.09-.53l-5.7-3.29A1,1,0,0,0,300.16,265.31Zm-11.44,6.61-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.9,0l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.3A1,1,0,0,0,288.72,271.92Zm20.88-12.06-6.46,3.73c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.06l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,309.6,259.86ZM257,308.12l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,257,308.12Zm63-53.76a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52ZM221.2,339.13l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.47,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,221.2,339.13ZM337,272.25l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.3A1,1,0,0,0,337,272.25Zm-18.41.28,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,318.62,272.53Zm10.3-13a1,1,0,0,0-.91.05l-6.46,3.74c-.27.15-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.4.09-.53Zm2-1.15,14.66,8.47a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-14.67-8.47a1,1,0,0,0-.9,0L331,257.86C330.72,258,330.68,258.25,330.91,258.38Zm-21.79,12.11-6.46,3.73c-.27.16-.32.39-.09.52l5.7,3.3a1,1,0,0,0,.91-.06l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,309.12,270.49ZM238,311.54l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.4.09-.52l-5.7-3.3A1,1,0,0,0,238,311.54Zm88.65-33.78a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91,0L321.07,274c-.27.15-.31.39-.09.52Zm-79.2,28.32L241,309.81c-.27.16-.31.4-.08.53l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.74c.28-.15.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,247.48,306.08Zm-74.41,60.37a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.4.09-.53l-5.7-3.29a1,1,0,0,0-.9,0l-6.46,3.74c-.28.15-.32.39-.09.52Zm-10.6-11.29L156,358.89c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91,0l6.46-3.74c.28-.15.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,162.47,355.16Zm20.95,5.78,6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.3A1,1,0,0,0,183.42,360.94Zm9.44-5.45,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,192.86,355.49Zm9.45-5.45,6.46-3.73c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.74c-.27.15-.31.39-.09.52l5.7,3.29A1,1,0,0,0,202.31,350Zm-30.4-.33-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,171.91,349.71Zm9.45-5.45L174.9,348c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.3A1,1,0,0,0,181.36,344.26Zm37.78-21.82-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.74c.27-.15.31-.39.09-.52L220,322.39A1,1,0,0,0,219.14,322.44Zm-9.45,5.46-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.32-.39.09-.52l-5.7-3.3A1,1,0,0,0,209.69,327.9ZM228.59,317l-6.47,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91,0l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,228.59,317ZM190.8,338.8l-6.46,3.73c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.74c.27-.15.31-.39.09-.52l-5.7-3.29A1,1,0,0,0,190.8,338.8Zm9.45-5.45-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29A1,1,0,0,0,200.25,333.35ZM187.91,368.7l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91,0l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.3A1.05,1.05,0,0,0,187.91,368.7Zm-50.17-2.56L132,362.85a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.74C137.92,366.51,138,366.27,137.74,366.14Zm12.44,3.17-5.7-3.29a1,1,0,0,0-.9.05l-10,5.74c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l9.94-5.74C150.37,369.67,150.41,369.44,150.18,369.31Zm-20.84-9.74-5.7-3.29a1,1,0,0,0-.9.06l-8,4.59c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l8-4.59C129.53,359.94,129.57,359.7,129.34,359.57Zm6.1-3.52a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.28.16-.32.39-.09.52Zm26.19,17-5.7-3.29a1,1,0,0,0-.9.05L142.6,377c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l12.43-7.18C161.82,373.41,161.86,373.18,161.63,373.05Zm4.49,7.76-5.7-3.29a1,1,0,0,0-.9.05l-8,4.59c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91-.06l7.95-4.59C166.31,381.17,166.35,380.94,166.12,380.81Zm39.55-65.3a1,1,0,0,0,.9-.05l6.47-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91,0l-6.46,3.73c-.28.16-.32.4-.09.53Zm-18.89,10.9a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.39.09-.52l-5.71-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52ZM144.89,350.6a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.4.09-.52l-5.7-3.3a1,1,0,0,0-.9.06l-6.46,3.73c-.28.16-.32.39-.09.52ZM196.22,321a1,1,0,0,0,.91,0l6.46-3.73c.28-.16.32-.4.09-.53l-5.7-3.29a1,1,0,0,0-.9.06l-6.47,3.73c-.27.16-.31.39-.09.52Zm-18.89,10.91a1,1,0,0,0,.91-.05l6.46-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.4-.09.53Zm-6,49.68a1,1,0,0,0-.91.05l-9.94,5.74c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9,0l10-5.74c.27-.16.31-.39.09-.52Zm-7.6-41.86a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.39-.09.52Zm-9.45,5.46a1,1,0,0,0,.91,0l6.46-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.4-.09.53Zm192-64.64a1.05,1.05,0,0,0-.91.06l-15.9,9.18c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05L352,284.33c.27-.16.32-.39.09-.52Zm-20.88,12.06a1,1,0,0,0-.9.05l-6.47,3.73c-.27.16-.31.4-.09.53l5.7,3.29a1,1,0,0,0,.91-.06l6.46-3.73c.28-.15.32-.39.09-.52ZM197.35,363.25l6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.3a1,1,0,0,0-.91.06l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,197.35,363.25ZM306.6,303.48a1,1,0,0,0-.91,0l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52Zm49.22-28.42a1,1,0,0,0-.91.05l-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.05l6.47-3.73c.27-.16.31-.4.09-.53ZM371,272.9l-14.67-8.47a1,1,0,0,0-.9.05l-6.46,3.74c-.28.15-.32.39-.09.52l14.66,8.46a1,1,0,0,0,.91-.05l6.46-3.73C371.15,273.26,371.19,273,371,272.9Zm-99.66,51a1,1,0,0,0-.9.05l-8,4.59c-.27.16-.31.39-.09.52l5.7,3.29a1,1,0,0,0,.91-.05l8-4.59c.28-.16.32-.39.09-.52Zm23.86-13.78a1,1,0,0,0-.9.05l-9.94,5.74c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l9.95-5.74c.27-.16.31-.39.08-.52Zm-45.73,26.4a1,1,0,0,0-.91.06l-53.19,30.71c-.27.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05L255,340.3c.27-.16.31-.39.09-.52Zm-56.18,32.44a1,1,0,0,0-.9.05l-8,4.59c-.27.16-.31.39-.09.52l5.7,3.3a1,1,0,0,0,.91-.06l8-4.59c.28-.16.32-.39.09-.52Zm67.11-38.75a1,1,0,0,0-.9.05l-7.95,4.59c-.28.16-.32.4-.09.53l5.7,3.29a1,1,0,0,0,.9-.05l8-4.6c.27-.16.31-.39.08-.52Zm-78.05,45.06a1,1,0,0,0-.9,0l-7.95,4.6c-.28.16-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l7.95-4.59c.28-.16.32-.4.09-.53Zm99.93-57.69a1,1,0,0,0-.91,0l-7.95,4.6c-.27.15-.31.39-.09.52L279,326a1,1,0,0,0,.91-.05l8-4.6c.27-.15.31-.39.09-.52ZM316,298a1,1,0,0,0-.9.06l-6.46,3.73c-.28.15-.32.39-.09.52l5.7,3.29a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.4.09-.53Zm20.51-15.14,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05L330,279.12c-.28.16-.32.39-.09.52l5.7,3.3A1,1,0,0,0,336.55,282.88Zm-38.81,1.71,6.46-3.74c.28-.15.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.4-.09.53l5.7,3.29A1,1,0,0,0,297.74,284.59Zm-24.82,35,18.89-10.9c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91.05L266.4,315.86c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,272.92,319.62Zm53.28-31.23a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91,0l-6.46,3.74c-.27.15-.31.39-.09.52Zm-8.06-5.23,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,318.14,283.16Zm-54.67,41.92,6.47-3.74c.27-.15.31-.39.08-.52l-5.7-3.29a1,1,0,0,0-.9.05L257,321.31c-.28.16-.32.4-.09.53l5.7,3.29A1,1,0,0,0,263.47,325.08Zm41.85-24.64a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91,0l-6.46,3.73c-.27.16-.31.39-.09.52Zm-89.08,51.9,6.47-3.73c.27-.16.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,216.24,352.34Zm9.45-5.45,6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.3a1,1,0,0,0-.9.06l-6.46,3.73c-.28.16-.32.39-.1.52l5.71,3.29A1,1,0,0,0,225.69,346.89ZM206.8,357.8l6.46-3.73c.28-.16.32-.4.09-.53l-5.7-3.29a1,1,0,0,0-.9.05L200.28,354c-.27.16-.31.4-.09.53l5.7,3.29A1,1,0,0,0,206.8,357.8ZM244.58,336l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.39-.09.52l5.7,3.29A1,1,0,0,0,244.58,336Zm-9.44,5.46,6.46-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.4-.09.53l5.7,3.29A1,1,0,0,0,235.14,341.44ZM254,330.53l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.3a1,1,0,0,0-.91.06l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,254,330.53ZM306.22,255a1,1,0,0,0,.9,0l6.47-3.73c.27-.16.31-.4.09-.53l-1.52-.87a1,1,0,0,0-.9,0l-6.47,3.73c-.27.16-.31.39-.09.52ZM259.1,284.66a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05l-6.47,3.73c-.27.16-.31.39-.09.52ZM278,273.75a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9,0l-6.46,3.73c-.28.16-.32.39-.09.52Zm-30.43,17.57a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.39.09-.52l-5.7-3.3a1,1,0,0,0-.91.06L242,287.51c-.27.16-.31.39-.09.52Zm21-12.11a1,1,0,0,0,.91,0l6.46-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.4-.09.53Zm-39.87,23a1,1,0,0,0,.9-.05l6.47-3.74c.27-.15.31-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.28.16-.32.4-.09.53Zm9.45-5.46a1,1,0,0,0,.9,0l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.9.05L232.51,293c-.28.16-.32.39-.09.52ZM287.33,266a1,1,0,0,0,.9-.06l6.47-3.73c.27-.16.31-.39.09-.52l-1.52-.88a1,1,0,0,0-.91.06l-6.46,3.73c-.27.16-.31.39-.09.52Zm28.34-16.36a1,1,0,0,0,.9-.06L323,245.8c.28-.16.32-.39.09-.52l-1.51-.88a1,1,0,0,0-.91.06l-6.46,3.73c-.28.16-.32.39-.09.52Zm12,6.91a1,1,0,0,0,.91-.05l6.46-3.73c.27-.16.31-.4.09-.53l-5.7-3.29a1,1,0,0,0-.91,0L322,252.69c-.27.15-.31.39-.09.52ZM346,277.43l6.46-3.73c.27-.16.32-.39.09-.52l-5.7-3.29a1,1,0,0,0-.91.05l-6.46,3.73c-.27.16-.31.39-.09.52l5.7,3.29A1,1,0,0,0,346,277.43Zm-49.22-16.94a1,1,0,0,0,.9-.05l6.46-3.73c.28-.16.32-.39.09-.52l-1.52-.88a1,1,0,0,0-.9.05l-6.46,3.73c-.28.16-.32.4-.09.53Zm-77.56,47.19a1,1,0,0,0,.91-.05l6.46-3.73c.28-.16.32-.39.09-.52l-5.7-3.3a1,1,0,0,0-.9.06l-6.47,3.73c-.27.16-.31.39-.09.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "242.814px 317.807px"
    },
    id: "elynx1nazsi0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.15 356.46 249.47 357.22 284.67 377.54 347.26 341.4 348.56 340.66 312.04 319.58 248.15 356.46",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.355px 348.56px"
    },
    id: "el362vpuahnk6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.68 341.74 312.04 321.76 250.05 357.56 284.67 377.54 346.68 341.74",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "298.365px 349.65px"
    },
    id: "elkiosg8mjwse",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Browser--inject-12",
    className: "animable animator-active",
    style: {
      transformOrigin: "248.458px 159.168px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Www--inject-12",
    className: "animable",
    style: {
      transformOrigin: "248.458px 159.168px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--www--inject-12",
    className: "animable",
    style: {
      transformOrigin: "294.61px 128.823px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.22,63.42c0-2.63-.92-4.49-2.41-5.36s-10.23-5.92-11.75-6.78-3.57-.73-5.85.59L203,146.13v54l11.7,6.75L377.9,112.65c4.6-2.65,8.32-9.09,8.32-14.4Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "294.61px 128.808px"
    },
    id: "elg8je0zgwg3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh4ruh5s9ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.22,63.42c0-2.63-.92-4.49-2.41-5.36s-10.23-5.92-11.75-6.78-3.57-.73-5.85.59L203,146.13v54l11.7,6.75L377.9,112.65c4.6-2.65,8.32-9.09,8.32-14.4Z",
    style: {
      opacity: 0.15,
      transformOrigin: "294.61px 128.808px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,58.62c4.6-2.65,8.32-.5,8.32,4.8V98.25c0,5.31-3.72,11.75-8.32,14.4L214.65,206.91v-54Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "300.435px 132.198px"
    },
    id: "elr3vaew804wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,108.2a12.42,12.42,0,0,0,5.6-9.7V66.32c0-2.54-1.79-3.57-4-2.31L217.94,156.4v43.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "299.885px 131.566px"
    },
    id: "el9prgnl3oufe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,173a1.69,1.69,0,0,1-.17.74,1.11,1.11,0,0,1-.42.51l-2.76,1.59a.31.31,0,0,1-.42,0,.74.74,0,0,1-.17-.54v-8.54a3.58,3.58,0,0,0-.46-2.06c-.31-.41-.79-.42-1.45,0a3.32,3.32,0,0,0-1.44,1.7,7.25,7.25,0,0,0-.44,2.59v8.54a1.72,1.72,0,0,1-.18.75,1.23,1.23,0,0,1-.42.51l-2.76,1.59a.31.31,0,0,1-.42,0,.74.74,0,0,1-.17-.54V157.58a1.81,1.81,0,0,1,.17-.74,1.11,1.11,0,0,1,.42-.51l2.76-1.6a.33.33,0,0,1,.42,0,.7.7,0,0,1,.18.54v7.19a10,10,0,0,1,1.16-2,5.77,5.77,0,0,1,1.82-1.71,4.41,4.41,0,0,1,1.93-.65,1.93,1.93,0,0,1,1.5.53,3.94,3.94,0,0,1,1,1.83,12.12,12.12,0,0,1,.35,3.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "239.976px 167.558px"
    },
    id: "eli5bf6cc7k6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39,162.66a1.88,1.88,0,0,0,.22,1.07c.14.19.39.2.72,0l1.76-1a.31.31,0,0,1,.41,0,.7.7,0,0,1,.18.54v3.41a1.68,1.68,0,0,1-.18.74,1,1,0,0,1-.41.51l-2.09,1.2a4.06,4.06,0,0,1-1.87.63,2,2,0,0,1-1.44-.49,3.35,3.35,0,0,1-.92-1.56,8.68,8.68,0,0,1-.33-2.59v-5.67l-1.62.93a.31.31,0,0,1-.42,0,.74.74,0,0,1-.17-.54v-3.41a1.85,1.85,0,0,1,.17-.74,1.11,1.11,0,0,1,.42-.51l1.62-.94v-5.5a1.68,1.68,0,0,1,.18-.74,1.1,1.1,0,0,1,.41-.51l2.77-1.59a.3.3,0,0,1,.41,0,.73.73,0,0,1,.18.54V152l2.48-1.43a.3.3,0,0,1,.41,0,.73.73,0,0,1,.18.54v3.41a1.72,1.72,0,0,1-.18.75,1.09,1.09,0,0,1-.41.51l-2.48,1.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "251.955px 157.791px"
    },
    id: "el6o76ouvuira",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,156.66a1.88,1.88,0,0,0,.22,1.07q.22.3.72,0l1.76-1a.31.31,0,0,1,.41,0,.7.7,0,0,1,.18.54v3.41a1.68,1.68,0,0,1-.18.74,1,1,0,0,1-.41.51l-2.08,1.2a4.13,4.13,0,0,1-1.88.63,2,2,0,0,1-1.44-.49,3.35,3.35,0,0,1-.92-1.56,9,9,0,0,1-.33-2.59v-5.67l-1.62.93a.29.29,0,0,1-.41,0,.7.7,0,0,1-.18-.54v-3.41a1.71,1.71,0,0,1,.18-.74,1.09,1.09,0,0,1,.41-.51l1.62-.94v-5.5A1.71,1.71,0,0,1,260,142a1.11,1.11,0,0,1,.42-.51l2.76-1.59a.32.32,0,0,1,.42,0,.78.78,0,0,1,.17.54V146l2.48-1.43a.31.31,0,0,1,.42,0,.74.74,0,0,1,.17.54v3.4a1.86,1.86,0,0,1-.17.75,1.16,1.16,0,0,1-.42.51l-2.48,1.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "262.345px 151.793px"
    },
    id: "elu4asn940gd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.82,156.9a3.52,3.52,0,0,1-1.12.44,1.88,1.88,0,0,1-.83,0,1.43,1.43,0,0,1-.6-.31,3,3,0,0,1-.39-.43v7.19a1.71,1.71,0,0,1-.18.74,1,1,0,0,1-.41.51l-2.77,1.6a.31.31,0,0,1-.41,0,.69.69,0,0,1-.18-.53V143.89a1.71,1.71,0,0,1,.18-.74,1.1,1.1,0,0,1,.41-.51l2.66-1.53a.31.31,0,0,1,.41,0,.7.7,0,0,1,.18.54v.77c.13-.3.27-.61.43-.95a5.5,5.5,0,0,1,.57-1,5.94,5.94,0,0,1,.83-.95,6,6,0,0,1,1.22-.89,4.17,4.17,0,0,1,1.86-.62,2,2,0,0,1,1.53.53,4.08,4.08,0,0,1,1.07,1.8,11.1,11.1,0,0,1,.45,3.18c0,.33,0,.78,0,1.36s0,1,0,1.38a17.51,17.51,0,0,1-.45,3.7,14.55,14.55,0,0,1-1.07,3,9.73,9.73,0,0,1-1.53,2.32A7.78,7.78,0,0,1,275.82,156.9Zm1-8.74a11.92,11.92,0,0,0,0-1.89,3.41,3.41,0,0,0-.5-1.77c-.29-.41-.78-.43-1.47,0a3,3,0,0,0-.83.72,3.9,3.9,0,0,0-.58,1,5.89,5.89,0,0,0-.37,1.07,8.08,8.08,0,0,0-.17,1.08c0,.35,0,.75,0,1.21s0,.83,0,1.15a4.58,4.58,0,0,0,.17.88,1.79,1.79,0,0,0,.37.65.84.84,0,0,0,.58.29,1.44,1.44,0,0,0,.83-.25,3.27,3.27,0,0,0,1.47-1.72A7.53,7.53,0,0,0,276.8,148.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "274.829px 152.36px"
    },
    id: "eltnpjxoz1u5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,137.48a1.78,1.78,0,0,1-.17.74,1.11,1.11,0,0,1-.42.51l-2.87,1.66a.33.33,0,0,1-.42,0,.7.7,0,0,1-.17-.54V135.4a1.66,1.66,0,0,1,.17-.74,1.11,1.11,0,0,1,.42-.51l2.87-1.66a.33.33,0,0,1,.42,0,.74.74,0,0,1,.17.54Zm0,11.82a1.85,1.85,0,0,1-.17.74,1.11,1.11,0,0,1-.42.51l-2.87,1.66a.33.33,0,0,1-.42,0,.73.73,0,0,1-.17-.54v-4.43a1.69,1.69,0,0,1,.17-.74,1.11,1.11,0,0,1,.42-.51l2.87-1.66a.33.33,0,0,1,.42,0,.78.78,0,0,1,.17.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "284.794px 142.35px"
    },
    id: "elzsraer3c34j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.94,119.42a4.13,4.13,0,0,1,.33-.88,1.59,1.59,0,0,1,.64-.69l2.71-1.57a.27.27,0,0,1,.34,0,.57.57,0,0,1,.15.44,1.56,1.56,0,0,1-.05.33l-7.38,31.57a4.7,4.7,0,0,1-.31.85,1.64,1.64,0,0,1-.66.72L289,151.76a.26.26,0,0,1-.34,0,.57.57,0,0,1-.15-.44,1.56,1.56,0,0,1,.05-.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "294.31px 134.022px"
    },
    id: "elyx660bawn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,115.08a4.13,4.13,0,0,1,.33-.88,1.59,1.59,0,0,1,.64-.69l2.72-1.57a.26.26,0,0,1,.34,0,.59.59,0,0,1,.14.44,1.56,1.56,0,0,1-.05.33l-7.38,31.57a5,5,0,0,1-.31.85,1.64,1.64,0,0,1-.66.72l-2.67,1.54a.26.26,0,0,1-.34,0,.57.57,0,0,1-.15-.44,1.56,1.56,0,0,1,.05-.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "301.85px 129.665px"
    },
    id: "el761z1oql754",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,114.68c.22-.13.39-.13.51,0a1,1,0,0,1,.24.4l1.62,6.73,1.62-8.6a4,4,0,0,1,.24-.68,1.21,1.21,0,0,1,.51-.56l2.72-1.57a.27.27,0,0,1,.37,0,.66.66,0,0,1,.15.48,1.46,1.46,0,0,1,0,.29l-3.49,17.64a3.51,3.51,0,0,1-.22.7,1.24,1.24,0,0,1-.5.56l-2.5,1.44c-.22.13-.38.13-.48,0a1.43,1.43,0,0,1-.24-.44l-1.56-6.18-1.55,8a3.75,3.75,0,0,1-.25.71,1.08,1.08,0,0,1-.48.55l-2.5,1.45c-.22.12-.38.13-.49,0a.93.93,0,0,1-.23-.44l-3.49-13.61a2.28,2.28,0,0,1,0-.26,1.4,1.4,0,0,1,.16-.66,1,1,0,0,1,.37-.46l2.72-1.57c.22-.12.38-.13.5,0a.88.88,0,0,1,.24.4l1.62,6.73,1.63-8.6a2.94,2.94,0,0,1,.24-.68,1.19,1.19,0,0,1,.5-.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "316.992px 123.01px"
    },
    id: "eluef7d21ebk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.94,103.72c.22-.13.39-.13.5,0a.83.83,0,0,1,.24.4l1.63,6.72,1.62-8.59a2.65,2.65,0,0,1,.24-.68,1.27,1.27,0,0,1,.5-.57l2.72-1.56a.29.29,0,0,1,.38,0,.66.66,0,0,1,.15.48,2.64,2.64,0,0,1,0,.28l-3.49,17.64a2.93,2.93,0,0,1-.23.71,1.17,1.17,0,0,1-.49.56l-2.5,1.44c-.22.13-.38.13-.48,0a1.26,1.26,0,0,1-.25-.44l-1.55-6.19-1.56,8a5,5,0,0,1-.24.71,1.12,1.12,0,0,1-.48.55l-2.5,1.45c-.22.12-.39.13-.49,0a.93.93,0,0,1-.23-.44l-3.49-13.62a2,2,0,0,1,0-.25,1.59,1.59,0,0,1,.15-.67,1.07,1.07,0,0,1,.37-.45l2.72-1.57c.22-.12.39-.13.51,0a1,1,0,0,1,.24.4l1.62,6.73,1.62-8.6a4,4,0,0,1,.24-.68,1.26,1.26,0,0,1,.51-.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "335.93px 112.046px"
    },
    id: "eluzugpg41sk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,92.76c.22-.13.39-.13.51,0a.86.86,0,0,1,.24.4l1.62,6.72,1.62-8.6a3.3,3.3,0,0,1,.25-.67,1.21,1.21,0,0,1,.5-.57l2.72-1.57a.3.3,0,0,1,.37,0,.68.68,0,0,1,.15.49,1.37,1.37,0,0,1,0,.28l-3.48,17.64a3.45,3.45,0,0,1-.23.71,1.17,1.17,0,0,1-.5.55l-2.5,1.45c-.22.13-.38.13-.48,0a1.55,1.55,0,0,1-.24-.44L354.89,103l-1.55,8a5,5,0,0,1-.24.71,1.19,1.19,0,0,1-.49.55l-2.5,1.44c-.21.13-.38.14-.49,0a1.09,1.09,0,0,1-.23-.44l-3.48-13.62a1,1,0,0,1,0-.25,1.47,1.47,0,0,1,.16-.67,1,1,0,0,1,.37-.45l2.72-1.57c.22-.13.38-.13.5,0a.83.83,0,0,1,.24.4l1.62,6.73,1.63-8.6a2.79,2.79,0,0,1,.24-.68,1.19,1.19,0,0,1,.5-.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "354.905px 101.104px"
    },
    id: "elf5t3pl8syje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,102a1.72,1.72,0,0,1-.18.75,1.14,1.14,0,0,1-.41.51l-2.87,1.65a.32.32,0,0,1-.42,0,.73.73,0,0,1-.18-.54V99.91a1.71,1.71,0,0,1,.18-.74,1.05,1.05,0,0,1,.42-.51L368.16,97a.31.31,0,0,1,.41,0,.7.7,0,0,1,.18.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "366.721px 100.956px"
    },
    id: "elenmqfffc97",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-12",
    className: "animable",
    style: {
      transformOrigin: "166.785px 194.701px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-12",
    className: "animable",
    style: {
      transformOrigin: "166.785px 194.701px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Circle--inject-12",
    className: "animable",
    style: {
      transformOrigin: "166.785px 194.701px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.44,137.15h0l-.08-.05h0l-20-11.88h0l-.11-.07h0c-8.81-5.32-20.57-4.48-33.21,3.78-25.41,16.59-44.77,56.82-43.24,89.86.76,16.47,6.56,28.05,15.34,33.46h0l.08.05h0l20,11.88h0l.09.06h0c8.81,5.33,20.58,4.5,33.24-3.77,25.4-16.58,44.76-56.82,43.24-89.86C222,154.14,216.22,142.57,207.44,137.15Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "166.794px 194.7px"
    },
    id: "elsh5cg27o05c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,263.78,126.2,252.3h0l-.08-.07c-8.78-5.42-14.58-17-15.34-33.44-.68-14.74,2.8-30.89,9.1-45.74l.13-.33,19.88,12.21c-6.31,14.84-9.78,31-9.1,45.74C131.52,246.79,137.1,258.22,145.57,263.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.133px 218.25px"
    },
    id: "elu9rg87t2i18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,260.47c25.4-16.58,44.76-56.82,43.24-89.86s-23.36-46.39-48.76-29.8-44.77,56.83-43.24,89.87S154.14,277.06,179.55,260.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "176.789px 200.641px"
    },
    id: "els6vkn2zt6ap",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,251.75a18.68,18.68,0,0,1-9.47-2.48c-8-4.6-12.59-15.15-12.59-29,0-25.39,15.43-55,34.4-66.06,8.62-5,17-5.66,23.73-1.82,8,4.6,12.59,15.16,12.59,29,0,25.38-15.43,55-34.4,66A28.61,28.61,0,0,1,165.21,251.75ZM191.8,153.8a24.86,24.86,0,0,0-12.33,3.77C161.55,168,147,196.14,147,220.32c0,12.39,3.89,21.73,10.68,25.64,5.44,3.13,12.51,2.48,19.9-1.82,17.92-10.42,32.5-38.57,32.5-62.74,0-12.4-3.89-21.74-10.68-25.65A15,15,0,0,0,191.8,153.8Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.51px 200.835px"
    },
    id: "eleatif7g17v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,188.27a18.17,18.17,0,0,1-11.42-3.93l1.77-2.26c5.85,4.58,13.74,4.38,22.24-.56,8.8-5.12,17.07-14.61,23.29-26.71l2.55,1.31c-6.46,12.59-15.13,22.49-24.4,27.88A28.24,28.24,0,0,1,165.2,188.27Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.705px 171.54px"
    },
    id: "eloofm91enqws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.94,246.9l-2.55-1.31c6.46-12.58,15.13-22.48,24.4-27.88,9.58-5.57,18.62-5.69,25.45-.34l-1.77,2.26c-5.85-4.58-13.74-4.38-22.24.56C170.43,225.31,162.16,234.8,155.94,246.9Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.315px 230.172px"
    },
    id: "elk1sq4j87vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81,248.33a7.66,7.66,0,0,1-3.88-1.08C164.19,243.38,160,229.4,160,210.79c0-25.67,7.82-50.31,17.79-56.11a7.9,7.9,0,0,1,8.3-.22c6.74,3.88,10.93,17.85,10.93,36.46,0,25.67-7.82,50.31-17.79,56.12A8.86,8.86,0,0,1,174.81,248.33Zm7.4-92.08a5.83,5.83,0,0,0-3,.91c-8.87,5.15-16.36,29.71-16.36,53.63,0,19.7,4.77,31.26,9.49,34a5.09,5.09,0,0,0,5.43-.21c8.87-5.16,16.36-29.72,16.36-53.64,0-19.7-4.77-31.26-9.49-34A4.87,4.87,0,0,0,182.21,156.25Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.51px 200.859px"
    },
    id: "elqixze3j3zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 155.92,
    width: 2.87,
    height: 89.88,
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.515px 200.86px"
    },
    id: "elxa1tsr55i3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldcike84m6ht"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.81,
    y: 199.42,
    width: 77.4,
    height: 2.87,
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "178.51px 200.855px",
      transform: "rotate(-30.1735deg)"
    },
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-12",
    className: "animable",
    style: {
      transformOrigin: "390.765px 153.535px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cursor--inject-12",
    className: "animable",
    style: {
      transformOrigin: "390.765px 153.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.59,137.48a3.11,3.11,0,0,0-1.19-1.39h0l-3-1.72h0c-1.29-.75-2.88,0-3.72.5l-1.86-1.07h0c-2.25-1.36-5.39,1.49-6.09,2.17l-.81-.46h0c-1.06-.64-2.5-.24-3.79.41V125.09a2.73,2.73,0,0,0-1.06-2.44h0l0,0-.05,0-2.93-1.7h0a2.72,2.72,0,0,0-2.68.28,8.46,8.46,0,0,0-3.82,6.63V161a4.69,4.69,0,0,0-.46-.21c-2.61-1.85-5.36-2.94-7.78-2.51a8.26,8.26,0,0,0-5,3.44c-1.26,2.23.82,3.63,3.51,6.7s5,6.72,7.45,9a13.18,13.18,0,0,0,4.19,2.85v4.34l2.95,1.71,22.48-13V169s2.79-11.12,3.68-15.77S414.31,141.05,412.59,137.48Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "390.786px 153.52px"
    },
    id: "elv85ti4ne9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaex4znoheop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.59,137.48a3.11,3.11,0,0,0-1.19-1.39h0l-3-1.72h0c-1.29-.75-2.88,0-3.72.5l-1.86-1.07h0c-2.25-1.36-5.39,1.49-6.09,2.17l-.81-.46h0c-1.06-.64-2.5-.24-3.79.41V125.09a2.73,2.73,0,0,0-1.06-2.44h0l0,0-.05,0-2.93-1.7h0a2.72,2.72,0,0,0-2.68.28,8.46,8.46,0,0,0-3.82,6.63V161a4.69,4.69,0,0,0-.46-.21c-2.61-1.85-5.36-2.94-7.78-2.51a8.26,8.26,0,0,0-5,3.44c-1.26,2.23.82,3.63,3.51,6.7s5,6.72,7.45,9a13.18,13.18,0,0,0,4.19,2.85v4.34l2.95,1.71,22.48-13V169s2.79-11.12,3.68-15.77S414.31,141.05,412.59,137.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "390.786px 153.52px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elha6t9asagrs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.16,136v3.67h0a16.16,16.16,0,0,1,2.89-2Zm13.58-1.6a6.58,6.58,0,0,0-1,.51l1,.56a3.33,3.33,0,0,1,1.41,1.55,7,7,0,0,1,1.7-1Zm-7,0a12.69,12.69,0,0,0-2,1.58l1.94,1.13a.41.41,0,0,1,.11.07,2.2,2.2,0,0,1,.76.65h0a12.66,12.66,0,0,1,2.07-1.68Zm-17.19-6.59V161a18.68,18.68,0,0,1,2.95,1.82V129.51ZM392.14,136h0v0Zm-9.9,43.15c-2.43-2.26-4.78-5.93-7.44-9-2.52-2.89-4.53-4.3-3.7-6.31l-3-1.71c-.82,2,1.17,3.42,3.7,6.32s5,6.71,7.44,9a13.31,13.31,0,0,0,4.19,2.85v4.35l3,1.7V182A13.13,13.13,0,0,1,382.24,179.11Z",
    style: {
      fill: "rgb(111, 70, 235)",
      opacity: 0.2,
      transformOrigin: "388.381px 157.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldq6n0z2kzwp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.16,136v3.67h0a16.16,16.16,0,0,1,2.89-2Zm13.58-1.6a6.58,6.58,0,0,0-1,.51l1,.56a3.33,3.33,0,0,1,1.41,1.55,7,7,0,0,1,1.7-1Zm-7,0a12.69,12.69,0,0,0-2,1.58l1.94,1.13a.41.41,0,0,1,.11.07,2.2,2.2,0,0,1,.76.65h0a12.66,12.66,0,0,1,2.07-1.68Zm-17.19-6.59V161a18.68,18.68,0,0,1,2.95,1.82V129.51ZM392.14,136h0v0Zm-9.9,43.15c-2.43-2.26-4.78-5.93-7.44-9-2.52-2.89-4.53-4.3-3.7-6.31l-3-1.71c-.82,2,1.17,3.42,3.7,6.32s5,6.71,7.44,9a13.31,13.31,0,0,0,4.19,2.85v4.35l3,1.7V182A13.13,13.13,0,0,1,382.24,179.11Z",
    style: {
      opacity: 0.1,
      transformOrigin: "388.381px 157.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,186.31V182a13.13,13.13,0,0,1-4.19-2.86c-2.43-2.26-4.78-5.93-7.44-9s-4.78-4.47-3.51-6.71a8.27,8.27,0,0,1,5-3.43c2.57-.46,5.49.79,8.24,2.83V129.51a8.46,8.46,0,0,1,3.83-6.62h0c2.11-1.22,3.82-.23,3.82,2.2v14.55s5.28-4.68,7.41-1.81c0,0,5.18-5.42,7.51-.84,0,0,3.81-3.07,5.52.49s.89,11.09,0,15.74S408.91,169,408.91,169v4.34Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "392.265px 154.339px"
    },
    id: "el4jxeue6l9ju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld1wgcrlf7no"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.43,186.31V182a13.13,13.13,0,0,1-4.19-2.86c-2.43-2.26-4.78-5.93-7.44-9s-4.78-4.47-3.51-6.71a8.27,8.27,0,0,1,5-3.43c2.57-.46,5.49.79,8.24,2.83V129.51a8.46,8.46,0,0,1,3.83-6.62h0c2.11-1.22,3.82-.23,3.82,2.2v14.55s5.28-4.68,7.41-1.81c0,0,5.18-5.42,7.51-.84,0,0,3.81-3.07,5.52.49s.89,11.09,0,15.74S408.91,169,408.91,169v4.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "392.265px 154.339px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluas05l645f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "400.455px 140.99px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.15,145.89s.48-6.64,2.92-8.22l-.08,0a16,16,0,0,0-2.84,1.94v-.12a.19.19,0,0,0,0,.12Z",
    id: "elr8994l3bp3e",
    className: "animable",
    style: {
      transformOrigin: "393.605px 141.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56,137.83v6.07s.67-6.24,2.07-7.75A12.56,12.56,0,0,0,399.56,137.83Z",
    id: "elasckbxhyi1h",
    className: "animable",
    style: {
      transformOrigin: "400.595px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,137h0v6.09s.38-6.14,1.7-7A7.24,7.24,0,0,0,407.07,137Z",
    id: "elfqezq2q9i1e",
    className: "animable",
    style: {
      transformOrigin: "407.92px 139.59px"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12",
    className: "animable",
    style: {
      transformOrigin: "354.935px 309.723px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-12",
    className: "animable",
    style: {
      transformOrigin: "354.935px 309.723px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.53,311.4c-17.27,8.61-25.11,17.65-16.17,24s33.27,14.92,33.27,14.92L356.82,361l35.34-20.41V328.48s-21.81-15-30.32-17.94S346.65,306.36,336.53,311.4Z",
    style: {
      opacity: 0.15,
      transformOrigin: "354.397px 334.488px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-12",
    className: "animable",
    style: {
      transformOrigin: "354.935px 309.723px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.26,366.13s-5.33,13.09-5.61,18.25c-.28,5.37-1.58,7.16-.67,13,.2,1.27.87,3.82,1,4.86a1.52,1.52,0,0,1-1.38,1.9c-2.34.49-6.21-3.9-8.06-8.67A142,142,0,0,1,366,378.67a7.36,7.36,0,0,1,.74-3.77,11.29,11.29,0,0,1,1.07-1.95c.77-2.34,1.14-6.79,1.79-9.87Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "375.621px 383.629px"
    },
    id: "el2x7e83v8g38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,383.57a5.6,5.6,0,0,0-.63,1.76c0,1.07,2.37,4.61,3.32,5.89a8.63,8.63,0,0,1,1.75,6.12c-.14,3.43,1.38,6.74,3.59,9.57a23.69,23.69,0,0,0,11.73,7.68c5.67,1.74,7.67-1.1,7.67-1.1s1.75-2.73.7-3.85S361.4,383.57,361.4,383.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.318px 399.362px"
    },
    id: "elkib0dwj82bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,373c-.17,0-.48-.05-.92.48-.17.2-1.2,2.75-2.06,4.09s-3.11,3.88-3.39,6.05c1.31,4.2,5.25,7.12,5.84,11.09s.66,8.56,6.75,13.42,12.36,5.35,14.61,4.06,2-3.69-1.09-8.29c-3.33-4.87-5.58-15.44-5.58-15.45a35.59,35.59,0,0,1-.59-4.49,30.58,30.58,0,0,1,.42-4.45,3.26,3.26,0,0,0-.28-2,3.41,3.41,0,0,0-1.68-1.16,14.44,14.44,0,0,0-3.13-1.06,5,5,0,0,0-3.22.39,22.81,22.81,0,0,1-2,1.28,2.87,2.87,0,0,1-3-.53,2.47,2.47,0,0,1-.81-2.75A6.6,6.6,0,0,1,367.77,373Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "375.745px 392.9px"
    },
    id: "elo24lh9am76q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.43,404.19a9.69,9.69,0,0,1,8.83-4.78c6.47,0,8.71,3.32,9.69,5.25,1.18,2.31,2.4,6.49-.27,7.69-2.89,1.29-6.23.89-11.48-1.74S370.43,404.19,370.43,404.19Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "380.355px 406.23px"
    },
    id: "el9xx2vl5bu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,384.7a.68.68,0,0,0,.59,0c1-.51,6.29-1.61,9.37,1.24.39-.32.31-.9-.2-1.72-3.6-2.29-8.61-1.27-9.81-.66a.61.61,0,0,0-.25.86A.65.65,0,0,0,371.61,384.7Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "376.519px 384.369px"
    },
    id: "elthjrqrlykxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.23,389.71a2,2,0,0,0-.37-1.78,12.12,12.12,0,0,0-9.37-.38.63.63,0,0,0-.25.86.7.7,0,0,0,.31.28.65.65,0,0,0,.59,0C374.11,388.2,379.12,387.15,382.23,389.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "377.231px 388.249px"
    },
    id: "elqulncafjy5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,398.45a3.67,3.67,0,0,0-.83-2.34c-3.59-2.17-8.48-1.17-9.67-.56a.62.62,0,0,0-.25.86.68.68,0,0,0,.89.28C376.07,396.15,381.9,395,384.87,398.45Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "379.453px 396.616px"
    },
    id: "elhhaegpvka1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,392.69a.68.68,0,0,0,.59,0c1-.51,6.17-1.58,9.27,1.15a2.26,2.26,0,0,0-.54-1.91,12.12,12.12,0,0,0-9.37-.38.63.63,0,0,0-.25.86A.67.67,0,0,0,373.48,392.69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.238px 392.314px"
    },
    id: "elhs90f3ttfs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,382.2s2.65,16,5.59,22.15,4.46,9.18,8.51,13.87c.88,1,2.89,2.91,3.61,3.74a1.6,1.6,0,0,1-.17,2.46c-1.8,1.72-9.44,2.13-13.72-1.08s-8.18-10-10.74-12.63c-1-1-1.86-2-2.72-3s-.6-2-.67-3.12c0-.55,0-2.05,0-2.05-.59-2.69-2.17-6.9-3-9.52Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "393.449px 403.969px"
    },
    id: "el9akvijg58vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,414.58a5.71,5.71,0,0,0,.2,1.95c.42,1,4.29,3.3,5.77,4.09a9.06,9.06,0,0,1,4.38,5c1.41,3.31,4.32,5.76,7.68,7.45a24.71,24.71,0,0,0,14.53,2c6.14-.88,6.76-4.46,6.76-4.46s.45-3.37-1.05-4S379.23,414.58,379.23,414.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.915px 424.992px"
    },
    id: "eladwu903ucgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.52,401.69c-.16.07-.47.16-.66.86-.06.27.1,3.14-.12,4.79s-1.21,5.05-.51,7.24c3.12,3.39,8.15,4.39,10.48,7.88s4.45,7.81,12.39,9.68,14.08-.45,15.64-2.67.28-4.41-4.74-7.36C407.67,419,400.83,410,400.82,410a37.59,37.59,0,0,1-2.56-4,30.21,30.21,0,0,1-1.59-4.39,3.43,3.43,0,0,0-1.17-1.78,3.5,3.5,0,0,0-2.1-.35,15.25,15.25,0,0,0-3.44.39,5.24,5.24,0,0,0-2.88,1.81,22.91,22.91,0,0,1-1.33,2.12,3,3,0,0,1-3.07.83,2.58,2.58,0,0,1-2-2.24A6.3,6.3,0,0,1,380.52,401.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "398.674px 416.134px"
    },
    id: "elljqnmx4qitm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,430.05a10.16,10.16,0,0,1,6.22-8.46c6.14-2.87,9.73-.75,11.52.64,2.14,1.66,5.16,5.07,3.17,7.4-2.15,2.51-5.49,3.62-11.64,3.48S397,430.05,397,430.05Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "407.78px 426.643px"
    },
    id: "eltbvg00q40z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.4,411.08a.7.7,0,0,0,.56-.26c.71-.93,5.22-4.34,9.41-3,.24-.48-.1-1-.95-1.55-4.43-.56-8.71,2.65-9.58,3.77a.63.63,0,0,0,.15.92A.67.67,0,0,0,389.4,411.08Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "394.074px 408.643px"
    },
    id: "elba9qoe1augn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.69,411.08a2.14,2.14,0,0,0-1.15-1.52c-4.22-.23-8.19,2.76-9,3.83a.65.65,0,0,0,.15.93.69.69,0,0,0,.41.13.71.71,0,0,0,.56-.27C393.33,413.28,397.61,410.05,401.69,411.08Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "396.549px 411.999px"
    },
    id: "ele1nrpr9im6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,418.17a3.83,3.83,0,0,0-1.83-1.84c-4.36-.45-8.54,2.68-9.4,3.79a.65.65,0,0,0,.15.93.76.76,0,0,0,.41.13.71.71,0,0,0,.56-.27C398.74,419.93,403.72,416.19,408.09,418.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "402.409px 418.733px"
    },
    id: "el94nl3eo79tr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.75,417.81a.69.69,0,0,0,.55-.26c.71-.92,5.13-4.26,9.28-3.05a2.36,2.36,0,0,0-1.36-1.57,12.62,12.62,0,0,0-9,3.83.64.64,0,0,0,.14.92A.72.72,0,0,0,394.75,417.81Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "399.332px 415.37px"
    },
    id: "el74wrqw03f69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,291.32c6.54,4.79,29.33,17.95,38.58,26.51,2.68,2.48,3.56,5.73,2.9,12.83-.89,9.64-8.46,42.47-8.46,42.47-1.05,1.85-2.88-1.66-2.88-1.66l-36.11-45.84Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "373.66px 332.494px"
    },
    id: "elfipcw96utyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr4ph040i68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.8,291.32c6.54,4.79,29.33,17.95,38.58,26.51,2.68,2.48,3.56,5.73,2.9,12.83-.89,9.64-8.46,42.47-8.46,42.47-1.05,1.85-2.88-1.66-2.88-1.66l-36.11-45.84Z",
    style: {
      opacity: 0.3,
      transformOrigin: "373.66px 332.494px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el620hs4hwbni"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.25,362.91c-8.35-7-35.34-49.57-35.34-49.57h0c3.68-3.1,5.57-13.87,5.57-13.87,1.46,4.15-.08,10.42-1.21,12.71,2.12,1.84,14.13,11.71,22.47,18.31A12,12,0,0,1,383.7,338C385.42,347,387.45,361.08,387.25,362.91Z",
    style: {
      opacity: 0.3,
      transformOrigin: "369.587px 331.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,291.32h0l-46.48,10.29c2.27,8.53,2.92,12.94,5.29,17.43s5,9.31,17.1,15.27c11.64,5.73,25.85,11.63,28.7,13,2.14,1,3.16,5.31,4.13,10.87,1,5.82,1.11,10.39,6.88,22.62,5.64,12,6.8,14.56,6.8,14.56s8.73.91,14.53-4.19c0,0-7.91-41.07-9.6-48.46-.94-4.13-1-6.3-6.09-10.84-4.39-3.89-24-18.75-24-18.75S360.83,302.63,355.8,291.32Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "351.035px 343.371px"
    },
    id: "el8t6g72mfcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb4knef68do6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.8,291.32h0l-46.48,10.29c2.27,8.53,2.92,12.94,5.29,17.43s5,9.31,17.1,15.27c11.64,5.73,25.85,11.63,28.7,13,2.14,1,3.16,5.31,4.13,10.87,1,5.82,1.11,10.39,6.88,22.62,5.64,12,6.8,14.56,6.8,14.56s8.73.91,14.53-4.19c0,0-7.91-41.07-9.6-48.46-.94-4.13-1-6.3-6.09-10.84-4.39-3.89-24-18.75-24-18.75S360.83,302.63,355.8,291.32Z",
    style: {
      opacity: 0.3,
      transformOrigin: "351.035px 343.371px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,214.1a4.55,4.55,0,0,0-2.31.47,15,15,0,0,0-2.35,1.53c-1.16.86-2.34,1.66-3.56,2.43a9.9,9.9,0,0,1-3.5,1.66c-.43.07-1.35.08-.88-.57a17.49,17.49,0,0,0,1.75-2.61,3.73,3.73,0,0,0,.26-3,1.3,1.3,0,0,0-.59-.71c-.41-.19-.62,0-.85.3a10,10,0,0,1-.82.77c-.58.51-1.16,1-1.73,1.54-3.35,3-7.42,5.67-8.85,10.06a27.44,27.44,0,0,0-1.18,8.35c0,4.82-.32,21.59-.32,21.59s-13.32-11.21-19.09-16c-2.79-2.33-6.68-5.16-11-5.57-3-.28-4.81-.27-4.81-.27l9.09,22s17.17,12.78,25.41,17.18c7.43,4,11.05,1.11,11.95-1,1.49-3.46,3-5.08.92-24.36-.15-1.49-.34-5.76-.51-7.25-.21-3.11.14-6.27,1.35-6.95a36.93,36.93,0,0,0,6.3-4.27,18.88,18.88,0,0,0,3.33-3.75,5.73,5.73,0,0,0,1.14-2.15,10.88,10.88,0,0,1,0-2.21c.15-.48.48-.88.6-1.4.25-1.07.16-2.29.83-3.21.38-.5,1-1,.91-1.58a1.3,1.3,0,0,0-1.07-.93A3.25,3.25,0,0,0,409.23,214.1Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "380.064px 244.237px"
    },
    id: "elkh8g7mtxfqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.64,222.47a14,14,0,0,1-3.47,6.94,8.19,8.19,0,0,0,2.95-3C396.08,224.43,396,223.42,395.64,222.47Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "394.03px 225.94px"
    },
    id: "el210khqafabf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,233.56c4.64.2,8.25.3,12.21,2.59s21.6,17.06,21.6,17.06.18-7.53.63-11.49c.31-2.75.77-3.61,1.63-3.48,0,0,1.53,2.35,5.86,2.68s5.8-1.48,5.8-1.48,1.27-.3,1.72,1.48,1.27,21,.48,26.53-3.27,8.11-6.6,8.89-11-3.89-20.29-10.11-19.31-12-19.31-12Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "373.64px 254.993px"
    },
    id: "el4gn9pze95ow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluop7qbopoji"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.51,233.56c4.64.2,8.25.3,12.21,2.59s21.6,17.06,21.6,17.06.18-7.53.63-11.49c.31-2.75.77-3.61,1.63-3.48,0,0,1.53,2.35,5.86,2.68s5.8-1.48,5.8-1.48,1.27-.3,1.72,1.48,1.27,21,.48,26.53-3.27,8.11-6.6,8.89-11-3.89-20.29-10.11-19.31-12-19.31-12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "373.64px 254.993px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo9m3v9rt1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.32,253.21a36.43,36.43,0,0,0,.39,10.78s-3.39-6.54-2.35-12.53Z",
    style: {
      opacity: 0.1,
      transformOrigin: "381.436px 257.725px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,237.62c-.77,4-8.46,42.55.29,71.26,15.77,1.86,43.45-5.38,47.6-15.81,0,0-2.79-9.9-4-14.75.26-7.94,0-23.1-.16-27.79-.32-9.29-1.77-16.48-6.38-17.16,0,0-9.26-.36-14.86-.13-4.84.19-8.48.25-8.48.25Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "332.416px 271.167px"
    },
    id: "el4qvkn6r9r2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,298.81c-1-2.26-19.73-13.81-19.73-13.81s.29-5.35,1.4-15.2,1.45-21.65-2.1-27.58l-3.58.14c-2,11.95-6.14,42.61,1.15,66.52,8.41,1,20.2-.61,30-3.89C338.89,303.77,334.36,300.61,333.55,298.81Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "323.619px 275.697px"
    },
    id: "el6d4081opdlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.78,224.45c0-2-3.79-7.94-5.52-12.65-2.89-7.87-3.14-14.94,4-18,0,0,4.46-7.69,15.71-8.08s19.88,9.11,16.15,21.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "334.682px 205.079px"
    },
    id: "el6lmgd9advnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.56,212.29c-1.47,0-2-2.11-3-3.24a4.35,4.35,0,0,0-6.72.84c-2.08,3-.06,7.34,2.21,9,2.85,2.12,4.82.08,4.82.08l-.26,15.89s.51,3.52,7,5.57c7.5,2.36,13.6-1.59,9.13-6.53l.17-4.19a21.5,21.5,0,0,0,7.25.4c2.5-.38,4.5-2.26,5.78-6.12,2.51-7.52,1.82-17.56-.77-26.72-2.48,2-13.92,5.63-24.23,2C327.29,205.6,327,212.29,325.56,212.29Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "334.238px 219.201px"
    },
    id: "elitg2ci8rq8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.48,217.2a.93.93,0,1,1-.93-.93A.93.93,0,0,1,321.48,217.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.55px 217.2px"
    },
    id: "eleisq5c729va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,229.72s-6.26-1.83-8.72-3.56a12,12,0,0,1-3.84-4.37,16.16,16.16,0,0,0,2.64,5.29c3,3.39,9.84,5,9.84,5Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "332.62px 226.935px"
    },
    id: "el0tsm4s4satu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4,212.21a1.56,1.56,0,1,1-1.59-1.6A1.59,1.59,0,0,1,338.4,212.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.84px 212.17px"
    },
    id: "el9xghqgkn85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.69,206.89l-3.36,1.78a2,2,0,0,1,.83-2.64A1.85,1.85,0,0,1,336.69,206.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.906px 207.246px"
    },
    id: "el03pggzfrm0fk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,220.39l5.35,1.71a3,3,0,0,1-3.63,1.86A2.74,2.74,0,0,1,337.91,220.39Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "340.497px 222.231px"
    },
    id: "elr2c147imbbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.1,206.83l-3.69-1a1.84,1.84,0,0,1,2.29-1.37A2,2,0,0,1,351.1,206.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.28px 205.611px"
    },
    id: "el7m9xb51w67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,211a1.56,1.56,0,1,1-1.59-1.6A1.59,1.59,0,0,1,350.15,211Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.59px 210.96px"
    },
    id: "elza0sfq8u9lc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,197.28c3.46-2.46,5.38-5.76,4.46-10.29-1.35,1.35-5.13,1.6-8.43,0a25.91,25.91,0,0,0-17-2.46c-6.11,1.19-9.69,5.83-9.69,9.25,1.2,2.44,2.84,3.74,5.68,5.47a22.65,22.65,0,0,0,14.74,4.24,14.55,14.55,0,0,0,8.68-3.14s-3.19.28-4.69-.71A16.52,16.52,0,0,0,351.87,197.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "338.885px 193.791px"
    },
    id: "el2v6cduptk35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.45 218.41 348.22 216.23 342.13 207.82 343.45 218.41",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "345.175px 213.115px"
    },
    id: "elbt1n8z2caoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-12",
    className: "animable",
    style: {
      transformOrigin: "353.304px 289.365px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el3h1115o5ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.83,319.53a9.55,9.55,0,0,0-1.44-1.7c-5.56-5.14-16-11.94-24.87-17.59l-40.36,23.3a.37.37,0,0,0,0,.64l29.31,16.93Z",
    style: {
      opacity: 0.15,
      transformOrigin: "362.403px 320.675px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,307.69v.65a2.68,2.68,0,0,1-1.34,2.32l-46.92,27.09a2.67,2.67,0,0,1-1.34.36,2.73,2.73,0,0,1-1.35-.36L331.55,323a2.7,2.7,0,0,1-1.34-2.32v-.91h0a.33.33,0,0,0,.17.3l28.08,16.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "369.14px 322.9px"
    },
    id: "elmngws0q1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,336.32v1.79a2.67,2.67,0,0,0,1.34-.36l46.92-27.09a2.68,2.68,0,0,0,1.34-2.32v-.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.27px 322.895px"
    },
    id: "el8knu31bna47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,307.68l-27.82-16.06a1.63,1.63,0,0,0-1.6,0l-48.26,27.87a.36.36,0,0,0,0,.62l28.08,16.21Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "369.142px 313.865px"
    },
    id: "elngyiy3179fc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.21 333.96 343.21 325.31 387.09 299.98 402.17 308.58 358.21 333.96",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "372.69px 316.97px"
    },
    id: "eleshvjzqf4rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.17 308.58 401.6 308.91 387.08 300.63 343.78 325.64 343.21 325.31 387.08 299.97 402.17 308.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.69px 312.805px"
    },
    id: "elhu414qoe2zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.84 309.89 351.12 310.05 358.47 314.29 371.55 306.74 371.82 306.58 364.19 302.18 350.84 309.89",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.33px 308.235px"
    },
    id: "el00zjntsrm4pw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.12 310.05 358.47 314.29 371.55 306.74 364.19 302.5 351.12 310.05",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "361.335px 308.395px"
    },
    id: "elf8zr3d0411",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-12",
    className: "animable",
    style: {
      transformOrigin: "328.638px 278.795px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.07,315.14c-2.1-2.08-5.15-5-7.72-5.83a16.76,16.76,0,0,0-1.8-.56,19.72,19.72,0,0,0,2.63-.52,4.68,4.68,0,0,0,2.23-1.48c.22-.29.38-.75.1-1a.59.59,0,0,0-.36-.13c-1.93-.06-3.44-.36-5.19-.48a7.12,7.12,0,0,0-2.35,0c-.72.19-1.43.4-2.13.65-3.19,1.1-6.1,2.09-10.61,1l-8.12-4.33s-1.74-.44-4.3,3.89-1.06,6.71-1.06,6.71l9.12,3.15h0l.13.05a30.4,30.4,0,0,0,4.31,1.9c2.84.87,6.48-.16,8.95-.29s6.66,1,9,1.94,5-2.6,6.19-2.18S367.18,317.23,365.07,315.14Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "345.986px 311.208px"
    },
    id: "el01ucz8pdqb7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,307.39A8.56,8.56,0,0,0,351,308a19,19,0,0,1,4.56.79,19.72,19.72,0,0,0,2.63-.52,4.94,4.94,0,0,0,2-1.24C358.82,307.93,356.15,307.56,354.48,307.39Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "355.595px 307.91px"
    },
    id: "elf556uwqnxqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,237.62c2.31.91,5.32,10.55,3.46,19.82l-4.3,29s5.27,3.12,12.67,7.7c5.12,3.18,9.51,6.09,9.52,8.44-3.36,1.2-6.38,7.38-5.36,10.6-2.29,2.72-23.45-9-30.85-14.07-3.43-2.35-5.16-3.27-3.84-13.86,1.46-11.72,2.46-24.74,4.75-33.43C298.83,242.73,301.48,239.21,310.4,237.62Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "311.503px 275.602px"
    },
    id: "elozin0rjmxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrk09v6aplfh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.4,237.62c2.31.91,5.32,10.55,3.46,19.82l-4.3,29s5.27,3.12,12.67,7.7c5.12,3.18,9.51,6.09,9.52,8.44-3.36,1.2-6.38,7.38-5.36,10.6-2.29,2.72-23.45-9-30.85-14.07-3.43-2.35-5.16-3.27-3.84-13.86,1.46-11.72,2.46-24.74,4.75-33.43C298.83,242.73,301.48,239.21,310.4,237.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "311.503px 275.602px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.23,336.72a3.16,3.16,0,0,0,2.73-.21l46.72-27a3.17,3.17,0,0,0,1.54-2.22l5.12-30.5a3.12,3.12,0,0,0,0-.52,3.16,3.16,0,0,0-.94-2.26l-48.54,28a2.35,2.35,0,0,0-1.15,1.64Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "387.29px 305.473px"
    },
    id: "elwok1brc9zdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,336.32l.32.19a3.55,3.55,0,0,0,.44.21l5.52-33a2.35,2.35,0,0,1,1.15-1.64l48.54-28a3.21,3.21,0,0,0-.65-.5l-48.64,28.09a2.31,2.31,0,0,0-1.14,1.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "386.455px 305.15px"
    },
    id: "eltr1rdjrauwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,302.69l-.76-.43a2.3,2.3,0,0,0-.44,1l-5.54,33.05.32.19a3.55,3.55,0,0,0,.44.21l5.52-33A2.42,2.42,0,0,1,365.21,302.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.84px 319.485px"
    },
    id: "elkjt5qf6n6dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.54,308.56c.34-2,2.45-4.75,4.71-6.05s3.81-.71,3.46,1.33-2.45,4.76-4.7,6.06S385.19,310.61,385.54,308.56Z",
    style: {
      fill: "rgb(111, 70, 235)",
      transformOrigin: "389.625px 306.205px"
    },
    id: "el73ly4elpae9",
    className: "animable"
  }))))), _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exp.4f187523.svg";
export { ForwardRef as ReactComponent };